/**
 * rename 거부 상태 코드 → 안내 범주. 범주 이름은 두 문구 자원(`timeSeriesLocale.layerRename`·`projects`
 * 네임스페이스의 `layerRename.*`)의 키 접미사와 같다 — 문구 자원은 화면마다 따로지만 상태 코드의 뜻은 서버
 * 계약 하나라 이 표에만 둔다.
 *
 * `shared/api` 의 `layerRenameErrorMessage`(2D `useRename2dLayer`·3D `useRename3dLayer`)와 projects-list 의
 * `renameErrorMessageKey`(`useRenameProjectLayer`·`useRenameDrawingMesh`·`useRenameDrawingBundle`)가 이 함수로
 * 범주를 고르므로, 상태 코드의 뜻이 바뀌면 레이어 표시명(`renameLayerDisplayName`)·도면·묶음 rename 다섯
 * mutation 의 안내가 함께 바뀐다. 에러에서 상태 코드를 꺼내는 식은 호출 경로마다 달라(Amplify 게이트웨이
 * `response.status ?? response.statusCode` · raw fetch 에러의 `status`) 호출부에 남는다.
 *
 * 폴더 쓰기(`folders.queries` 의 `describeFolderWriteFailure` — 폴더 이름 변경 포함)는 이 표를 쓰지 않는다:
 * 400·409 는 서버 문구를 보인다.
 *
 * import 없는 리프다 — 두 도메인의 쿼리 모듈이 서로를 import 하지 않고 같은 표를 쓴다.
 */
export type RenameRejectionKey =
  | "renameDuplicate"
  | "renameInvalid"
  | "renameNoPermission"
  | "renameFailed";

const RENAME_REJECTION_KEY_BY_STATUS = {
  409: "renameDuplicate",
  400: "renameInvalid",
  403: "renameNoPermission",
  404: "renameNoPermission",
} as const;

/** 표에 없는 상태(상태 코드가 없는 네트워크 실패 포함)는 `renameFailed` 로 떨어진다. */
export const renameRejectionKey = (status: unknown): RenameRejectionKey =>
  RENAME_REJECTION_KEY_BY_STATUS[
    status as keyof typeof RENAME_REJECTION_KEY_BY_STATUS
  ] ?? "renameFailed";
